import { Box, Button, IconButton, Text } from '@chakra-ui/react';
import { DialogActionTrigger, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogRoot, DialogTitle } from '@src/components/chakra-ui/dialog';
import { MenuContent, MenuItem, MenuRoot, MenuTrigger } from '@src/components/chakra-ui/menu';
import { usePitchDeckUpload } from '@src/components/sco/PitchDeckAuditor/hooks/usePitchDeckUpload';
import { useState } from 'react';
import { LuSettings, LuTrash2 } from 'react-icons/lu';

/**
 * Per-card overflow ("gear") menu. Lives inside a clickable card, so it stops click
 * propagation to avoid triggering the card's navigation. Delete soft-deletes the deck
 * (and its audit/chat) and refreshes the list.
 */
export function PitchDeckCardMenu({
  pitchDeckId,
  title
}: {
  pitchDeckId: string;
  title: string;
}) {
  const {
    deleteDeck,
    deleting
  } = usePitchDeckUpload();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const stop = (e: {
    stopPropagation: () => void;
  }) => e.stopPropagation();
  const onConfirmDelete = async () => {
    try {
      await deleteDeck(pitchDeckId);
    } finally {
      setConfirmOpen(false);
    }
  };
  return <Box onClick={stop}>
      <MenuRoot>
        <MenuTrigger asChild>
          <IconButton aria-label={'Deck options'} size={'xs'} variant={'ghost'} onClick={stop}>
            <LuSettings />
          </IconButton>
        </MenuTrigger>
        <MenuContent>
          <MenuItem _hover={{
          bg: 'red.subtle'
        }} color={'red.fg'} value={'delete'} onClick={() => setConfirmOpen(true)}>
            <LuTrash2 />
            Delete
          </MenuItem>
        </MenuContent>
      </MenuRoot>

      <DialogRoot open={confirmOpen} role={'alertdialog'} onOpenChange={e_0 => setConfirmOpen(e_0.open)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Delete this pitch deck?</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <Text color={'fg.muted'} fontSize={'sm'}>
              &ldquo;{title}&rdquo; and its audit, scores, and chat history will be removed.
            </Text>
          </DialogBody>
          <DialogFooter>
            <DialogActionTrigger asChild>
              <Button size={'sm'} variant={'outline'}>
                Cancel
              </Button>
            </DialogActionTrigger>
            <Button colorPalette={'red'} loading={deleting} size={'sm'} onClick={onConfirmDelete}>
              <LuTrash2 />
              Delete
            </Button>
          </DialogFooter>
        </DialogContent>
      </DialogRoot>
    </Box>;
}